<template>
    <div class="float-right">
        <span style="font-size: 16px" class="p-0">
            <b-link @click="decrement()">
                <i class="fas fa-chevron-square-left mr-2 mt-0 mb-0"></i>
            </b-link>
            {{ start | moment('Y') }}
            <b-link class="white-link" @click="increment()">
                <i class="fas fa-chevron-square-right ml-2 mt-0 mb-0"></i>
            </b-link>
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'YearHandler',

    props: {
        next: '',
        prev: '',
        start: '',
        end: '',
    },

    methods: {
        increment() {
            console.log('increment', this.next)
            this.$store.commit('timeSheetsVM/SET_CURRENT_DATE', this.next)
            this.$emit('year-has-changed')
            // this.updateData()
        },

        decrement() {
            console.log('decrement', this.prev)
            this.$store.commit('timeSheetsVM/SET_CURRENT_DATE', this.prev)
            this.$emit('year-has-changed')
            // this.updateData()
        },
    },
}
</script>

<style scoped>
a {
    text-decoration: none;
    background-color: transparent;
}

a:hover {
    text-decoration: none;
}
</style>
